import { useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { useQueryClient } from '@tanstack/react-query';
import { flushDeferredCalendarRefresh } from '../../query/menuCalendarRefreshDefer';

/** Flush deferred calendar invalidations when the menu tab loses focus (incl. bottom-tab switch). */
export function useMenuCalendarRefreshOnLeave(customer_id: number | undefined): void {
  const query_client = useQueryClient();

  useFocusEffect(
    useCallback(() => {
      return () => {
        if (typeof customer_id === 'number') {
          void flushDeferredCalendarRefresh(query_client, customer_id);
        }
      };
    }, [customer_id, query_client]),
  );
}
